module.exports = __webpack_public_path__ + "static/media/roles.6cf4c739.svg";